if (!customElements.get('product-info')) {
  const ROUTE_ADD_TO_CART = window.Shopify.routes.root + 'cart/add.js'
  
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('.quantity__input');
        this.currentVariant = this.querySelector('.product-variant-id');
        this.variantSelects = this.querySelector('variant-radios');
        this.submitButton = this.querySelector('[type="submit"]');
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        if (!this.input) return;
        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;
        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
          if (event.data.sectionId !== sectionId) return;
          this.updateQuantityRules(event.data.sectionId, event.data.html);
          this.setQuantityBoundries();
        });
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: this.input.step ? parseInt(this.input.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.input.min = min;
        this.input.max = max;
        this.input.value = min;
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        if (!this.currentVariant || !this.currentVariant.value) return;
        this.querySelector('.quantity__rules-cart .loading-overlay').classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`)
          .then((response) => {
            return response.text();
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
            this.setQuantityBoundries();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.querySelector('.quantity__rules-cart .loading-overlay').classList.add('hidden');
          });
      }

      updateQuantityRules(sectionId, html) {
        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) current.setAttribute(attribute, valueUpdated);
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }
    }
  );

  // Init owl Variant image
  const productVariantImage = document.querySelectorAll('.product-variants-image')
  if (productVariantImage.length > 0) {
    productVariantImage.forEach(section => {
      const swiper = new Swiper(section.querySelector('.swiper'), {
        loop: false,
        spaceBetween: 4,
        slidesPerView: 'auto'
      })
    })
  }

  // Init owl Variant image
  const productVariantSize = document.querySelectorAll('.product-form__input-list')
  if (productVariantSize.length > 0) {
    productVariantSize.forEach(section => {
      const swiper = new Swiper(section.querySelector('.swiper'), {
        loop: false,
        spaceBetween: 0,
        slidesPerView: 'auto',
        navigation: {
          nextEl: section.querySelector('.product-size-sticky__variants-list .swiper-button-next'),
          prevEl: section.querySelector('.product-size-sticky__variants-list .swiper-button-prev'),
        }
      })
    })
  }
  
  const elmOpenBoxSize = document.querySelector('.product-size-sticky__size')
  const elmBtnClosePopup = document.querySelector('.btn-close-sticky-size')
  const elmBtnSubmitStickys = document.querySelectorAll('.product-size-sticky__btn-add-to-cart')
  const elmOverlay = document.querySelector('.section-overlay')
  const inputStickyVariants = document.querySelectorAll('.product-size-sticky__variants .product-form__input input[type=radio]')
  const inputSizeVariants = document.querySelectorAll('.product__info-wrapper-info-desktop__variants .product-form__input input[type=radio]')

  // Size chart
  const elmOpentSizeCharts = document.querySelectorAll('.product-sizeguide')
  const elmSizeChart = document.querySelector('.product-size-chart')
  const elmCloseSizeChart = document.querySelector('.btn-close-size-popup')

  if (elmOverlay) {
    elmOverlay.addEventListener('click', function () {
      document.body.classList.remove('open-popup-size')
      elmOpenBoxSize.classList.remove('open')

      if (!elmSizeChart?.classList.contains('hidden')) {
        elmSizeChart?.classList.add('hidden')
        document.body.classList.remove('open-popup-size-chart')
      }
    })
  }

  if (elmOpenBoxSize) {
    elmOpenBoxSize.addEventListener('click', function () {
      elmOpenBoxSize.classList.toggle('open')
      document.body.classList.toggle('open-popup-size');
      document.querySelector('.product-size-sticky__show-more-payment').closest('.product-size-sticky').classList.remove('show-more');
    })
  }

  if (elmBtnClosePopup) {
    elmBtnClosePopup.addEventListener('click', function () {
      document.body.classList.remove('open-popup-size')
      elmOpenBoxSize.classList.remove('open')
    })
  }

  if (elmBtnSubmitStickys) {
    elmBtnSubmitStickys.forEach(elmBtnSubmitSticky => {
      elmBtnSubmitSticky.addEventListener('click', function(e) {
        let variantStickyIsChecked = false;
        let stickyVariants = []
        const elmForm = document.getElementById('btn-addToCart')
        const elmParent = elmForm.closest('.product-size-sticky__btn-add-to-cart')

        if(elmBtnSubmitSticky.closest('.product-size-sticky__btn-add-to-cart')?.classList.contains('use-variant-select-size')) {
          stickyVariants = document.querySelectorAll('.product-size-sticky__variants-list input[type=radio]')
          stickyVariants.forEach((sizeVariant) => {
            if(sizeVariant.checked) {
              variantStickyIsChecked = true;
            }
          })
          if(variantStickyIsChecked || !(stickyVariants.length > 1)) {
            const elementId = document.querySelector('input[name="id"]');
            const elementCustomSize = document.querySelector('input[name="properties[Size]"]')
            const dataSizeCustom = elementCustomSize.getAttribute('value')
            let formData = {}

            if (dataSizeCustom) {
              formData = {
                'items': [{
                  'id': parseInt(elementId.getAttribute('value')),
                  'quantity': 1,
                  'properties': {
                    'customSize': dataSizeCustom.trim(),
                  }
                }]
              }
            } else {
              formData = {
                'items': [{
                  'id': parseInt(elementId.getAttribute('value')),
                  'quantity': 1
                }]
              }
            }

            fetch(ROUTE_ADD_TO_CART, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(formData)
            })
            .then(response => {
              if (response.ok) {
                document.getElementById('cart-icon-bubble').click()
                refreshMiniCart()
                initProductsRecommendationSwiper()
                document.querySelector('.product-messages').classList.add('hidden')
              } else {
                // document.querySelector('.product-messages').textContent = window.addToCart.error.replace(
                //   "[product]",
                //   dataSizeCustom
                // )

                // document.querySelector('.product-messages').classList.remove('hidden')
              }
            })
            .catch((error) => {
              initProductsRecommendationSwiper()
              console.error(error)
            })

          }else {
            handleRequiredSize()
          }
        } else {
          stickyVariants = document.querySelectorAll('.product__info-wrapper-info-desktop__variants .product-form__input input[type=radio]');
          stickyVariants.forEach((sizeVariant) => {
            if(sizeVariant.checked) {
              variantStickyIsChecked = true;
            }
          })

          if(variantStickyIsChecked || !(stickyVariants.length > 1)) {
            if (elmForm  && !elmParent.classList.contains('use-variant-select-size')) {
              elmForm.click();
            }
          }else {
            handleRequiredSize()
          }
        }
      })
    })
  }

  function handleRequiredSize() {
    const errorMessageElement = document.querySelector('.message-error-sticky-add-cart');
    const selectSizeList = document.querySelector('.product-size-sticky__variants');
    errorMessageElement.classList.remove('hidden');
    selectSizeList.classList.add('select-size');
      setTimeout(() => {
      errorMessageElement.classList.add('hidden');
      selectSizeList.classList.remove('select-size');
    }, 5000);
  }

  if (inputStickyVariants && inputSizeVariants) {
    inputStickyVariants.forEach((stickyVariant) => {
      stickyVariant.addEventListener('click', () => {
        const stickyVariantId = stickyVariant.getAttribute('data-input-variant-id');
    
        inputSizeVariants.forEach((sizeVariant) => {
          const sizeVariantId = sizeVariant.getAttribute('data-input-variant-id');
    
          if (stickyVariantId === sizeVariantId) {
            sizeVariant.click();
          }
        });
      });
    });
  }

  if (elmOpentSizeCharts.length > 0) {
    elmOpentSizeCharts.forEach(elm => {
      elm.addEventListener('click', function () {
        elmSizeChart?.classList.remove('hidden')
        document.body.classList.add('open-popup-size-chart')
      })
    })
  }

  if (elmCloseSizeChart) {
    elmCloseSizeChart.addEventListener('click', function () {
      elmSizeChart?.classList.add('hidden')
      document.body.classList.remove('open-popup-size-chart')
    })
  }

  const elmDescription = document.querySelector('.product__description')
  const elmReadMore = document.querySelector('.btn-readmore')
  const elmReadLess = document.querySelector('.btn-readless')
  if (elmDescription) {
    const scrollHeight = elmDescription.offsetHeight
    if (scrollHeight > 55) {
      elmDescription.style.height = '55px'
      elmReadMore.classList.remove('hidden')
    }
  }

  if (elmReadMore) {
    elmReadMore.addEventListener('click', function () {
      elmDescription.style.height = 'auto'

      elmReadMore.classList.add('hidden')
      elmReadLess.classList.remove('hidden')
    })
  }

  if (elmReadLess) {
    elmReadLess.addEventListener('click', function () {
      elmDescription.style.height = '55px'

      elmReadLess.classList.add('hidden')
      elmReadMore.classList.remove('hidden')
    })
  }

  // Add to cart product
  function addToCartProduct() {
    const btnAdd = document.getElementById('btn-addToCart')
    let variantIsChecked = false;
    let sizeVariants = []
    if (btnAdd) {
      btnAdd.addEventListener('click', (e) => {
        if(btnAdd.closest('.product-size-sticky__btn-add-to-cart').classList.contains('use-variant-select-size')) {
          sizeVariants = document.querySelectorAll('.section-variant-selector-size__container input[type=radio]')
          sizeVariants.forEach((sizeVariant) => {
            if(sizeVariant.checked) {
              variantIsChecked = true;
            }
          })
        } else {
          sizeVariants = document.querySelectorAll('.product__info-wrapper-info-desktop__variants .product-form__input input[type=radio]');
          sizeVariants.forEach((sizeVariant) => {
            if(sizeVariant.checked) {
              variantIsChecked = true;
            }
          })
        }

        if(variantIsChecked || !(sizeVariants.length > 1)) {
          e.preventDefault()
          const elementId = document.querySelector('input[name="id"]');
          const elementCustomSize = document.querySelector('input[name="properties[Size]"]')
          let dataId = null
          let dataSizeCustom = null
          let loadURL = window.location.href
          if (loadURL.includes('?')) {
            let urlResult = loadURL.split('?')[1]
            let urlParams = new URLSearchParams(urlResult)
            let variant = urlParams.get('variant')
            dataId = variant
          } else {
            dataId = elementId.getAttribute('value')
          }

          dataSizeCustom = elementCustomSize.getAttribute('value')
          let formData = {}

          if (dataSizeCustom) {
            formData = {
              'items': [{
                'id': dataId,
                'quantity': 1,
                'properties': {
                  'customSize': dataSizeCustom,
                }
              }]
            }
          } else {
            formData = {
              'items': [{
                'id': dataId,
                'quantity': 1
              }]
            }
          }

          fetch(ROUTE_ADD_TO_CART, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
          })
          .then(response => {
            if (response.ok) {
              document.getElementById('cart-icon-bubble').click()
              refreshMiniCart()
              initProductsRecommendationSwiper()
              document.querySelector('.product-messages').classList.add('hidden')
            } else {
              document.querySelector('.product-messages').textContent = window.addToCart.error.replace(
                "[product]",
                dataSizeCustom
              )

              document.querySelector('.product-messages').classList.remove('hidden')
            }
          })
          .catch((error) => {
            initProductsRecommendationSwiper()
            console.error(error)
          })
        }else {
          const errorMessageElements = document.querySelectorAll('.message-error-add-cart');
          if (errorMessageElements.length > 0) {
            errorMessageElements.forEach(errorMessageElement => {
              errorMessageElement.classList.remove('hidden');
              setTimeout(() => {
              errorMessageElement.classList.add('hidden');
            }, 5000);
            })
          }
        }
      })
    }
  }

  addToCartProduct()

  function handleCustomOpenModalNotify() {
    // const elmBtns = document.querySelectorAll('.btn-trigger-app')
    // if (elmBtns.length > 0) {
    //   elmBtns.forEach(btn => {
    //     btn.addEventListener('click', function() {
    //       document.querySelector('#BIS_trigger').click()
    //     })
    //   })
    // }
  }

  handleCustomOpenModalNotify()

  function handleShowMorePaymentSticky() {
    const elmShowMorePayments = document.querySelector('.product-size-sticky__show-more-payment')
    if(elmShowMorePayments) {
      elmShowMorePayments.addEventListener('click', function() {
        elmShowMorePayments.closest('.product-size-sticky').classList.toggle('show-more');
        document.body.classList.remove('open-popup-size');
        document.querySelector(".product-size-sticky__size").classList.remove('open');
      })
    }
  }
  handleShowMorePaymentSticky()
}

function isOutOfViewport(element) {
  const rect = element.getBoundingClientRect();
  const windowHeight = window.innerHeight || document.documentElement.clientHeight;
  const windowWidth = window.innerWidth || document.documentElement.clientWidth;

  return (
      rect.bottom < 0 ||
      rect.top > windowHeight ||
      rect.right < 0 ||
      rect.left > windowWidth
  )
}

function toggleStickyBar() {
  const footer = document.querySelector('footer')
  const productButtons = document.querySelector('.rocket-element__check-sticky')
  const stickyBar = document.querySelector('.product-size-sticky')    

  if (!productButtons || !stickyBar) return;

  if (isOutOfViewport(footer)) {
    stickyBar.classList.remove('hidden')
  } else {
    stickyBar.classList.add('hidden')
  }

  if (isOutOfViewport(productButtons)) {
    stickyBar.classList.add('is-sticky')
  } else {
    stickyBar.classList.remove('is-sticky')
  }
}
toggleStickyBar()

window.addEventListener('scroll', () => {
  toggleStickyBar()
})

//reinit minicart
export function refreshMiniCart() {
  document.querySelector('#CartDrawer #mincart-loading').classList.remove('hidden')
  fetch(window.Shopify.routes.root +'/cart').then(function (response) {
    // When the page is loaded convert it to text
    return response.text()
  })
    .then(function (html) {
      // Initialize the DOM parser
      const parser = new DOMParser()

      // Parse the text
      const doc = parser.parseFromString(html, 'text/html')
      if (document.querySelector('body').classList.contains('template-cart')) {
        const contentCartHtml = doc.querySelector('#cart-template').innerHTML
        const cartCount = parseInt(doc.querySelector('#minicart-count').innerHTML)
        if (cartCount === 0) {
          document.querySelector('#minicart-count').classList.add('hidden')
        } else {
          document.querySelector('#minicart-count').classList.remove('hidden')
          document.querySelector('#minicart-count').innerHTML = cartCount
        }
        document.querySelector('#cart-template').innerHTML = contentCartHtml
        document.querySelector('#CartDrawer #mincart-loading').classList.add('hidden')
      }

      getElementMiniCart(doc)
    })
    .catch(function (err) {
      console.error(err)
      document.querySelector('#CartDrawer #mincart-loading').classList.add('hidden')
    })
}

function getElementMiniCart(doc) {
  if (doc.getElementById('minicart-count')) {
    const cartCount = parseInt(doc.querySelector('#minicart-count').innerHTML)
    if (cartCount === 0) {
      document.querySelector('#minicart-count').classList.add('hidden');
      document.querySelector('#minicart-actions').classList.add('hidden');
      document.querySelector('#minicart-items').classList.add('mb-8');
      document.querySelector('#minicart-base').className = 'minicart-items cart-content h-full';
      document.querySelector('.mini-cart-content').classList.add('no-item');

      // count item on header
      document.querySelector('.header__icon--cart #minicart-count').classList.remove('hidden');
      document.querySelector('.header__icon--cart #minicart-count').innerHTML = cartCount;

      document.querySelector('cart-drawer').classList.remove('is-empty');
    } else {
      document.querySelector('#minicart-count').classList.remove('hidden');
      document.querySelector('#minicart-count').innerHTML = cartCount;
      document.querySelector('#minicart-items').classList.remove('mb-8');
      document.querySelector('#minicart-base').className = 'minicart-items h-full';
      document.querySelector('.mini-cart-content').classList.remove('no-item');
      document.querySelector('#minicart-actions').classList.remove('hidden');
      document.querySelector('#minicart-actions').classList.remove('is-empty');


      // count item on header
      document.querySelector('.header__icon--cart #minicart-count').classList.remove('hidden');
      document.querySelector('.header__icon--cart #minicart-count').innerHTML = cartCount;
      document.querySelector('cart-drawer').classList.remove('is-empty');
    }
  } else {
    document.querySelector('#minicart-count').classList.add('hidden');
  }

  const headingCartHtml = doc.querySelector('#cart-heading').innerHTML;
  const contentCartHtml = doc.querySelector('#minicart-items').innerHTML;
  const actionCartHtml = doc.querySelector('#minicart-actions').innerHTML;
  if (contentCartHtml && headingCartHtml) {
    document.querySelector('#cart-heading').innerHTML = headingCartHtml;
    document.querySelector('#minicart-items').innerHTML = contentCartHtml;
    document.querySelector('#minicart-actions').innerHTML = actionCartHtml;
  }
  document.querySelector('#CartDrawer #mincart-loading').classList.add('hidden')
  initProductsRecommendationSwiper()
}

function initProductsRecommendationSwiper() {
  const elmRecommendations = document.querySelectorAll('.cart-section-recommendation')
  elmRecommendations.forEach(section => {
    const swiper = new Swiper(section.querySelector('.swiper'), {
      loop: false,
      spaceBetween: 5,
      slidesPerView: 'auto',
      mousewheel: {
        forceToAxis: true,
      },
      navigation: {
        nextEl: section?.querySelector('.swiper-button-next'),
        prevEl: section?.querySelector('.swiper-button-prev'),
      }
    })
  })
}

